import React from 'react';

export const FlexRow = ({ className = '', children, onClick = () => {} }) => (
  <div className={`flex flex-row ${className}`} onClick={onClick}>
    {children}
  </div>
);
